import { Component, AfterViewInit, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { LanguageService } from '../../services/language.service';
import { LanguageSelectorComponent } from '../../components/shared/language-selector/language-selector';
import { PolicyModalComponent } from '../../components/shared/policy-modal/policy-modal';
import { Subject, takeUntil, combineLatest } from 'rxjs';

@Component({
	selector: 'app-support-prelogin',
	standalone: true,
	imports: [CommonModule, RouterModule, LanguageSelectorComponent, PolicyModalComponent],
	templateUrl: './support-prelogin.html',
	styleUrls: ['./support-prelogin.scss']
})
export class SupportPreloginComponent implements OnInit, AfterViewInit, OnDestroy {
	private destroy$ = new Subject<void>();
	whatsappUrl = '';

	constructor(private languageService: LanguageService) {}

	ngOnInit(): void {
		// Set appropriate WhatsApp URL based on device
		this.setWhatsAppUrl();
	}

	// translations helper
	t(key: string): string {
		return this.languageService.t(key);
	}

	ngAfterViewInit(): void {
		// Remove underlines from phone number links after view initializes
		this.removeUnderlinesFromLinks();
		
		// Also remove after translations load
		combineLatest([
			this.languageService.currentLanguage$,
			this.languageService.translations$
		])
			.pipe(takeUntil(this.destroy$))
			.subscribe(() => {
				setTimeout(() => this.removeUnderlinesFromLinks(), 100);
			});
	}

	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
	}

	private setWhatsAppUrl(): void {
		const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
		
		if (isMobile) {
			// For mobile devices, use wa.me URL to open WhatsApp app
			this.whatsappUrl = 'https://wa.me/917378932424';
		} else {
			// For desktop, use WhatsApp Web
			this.whatsappUrl = 'https://web.whatsapp.com/send?phone=917378932424';
		}
	}

	private removeUnderlinesFromLinks(): void {
		setTimeout(() => {
			const infoContentElements = document.querySelectorAll('.support-prelogin-container .info-content');
			infoContentElements.forEach((element) => {
				const links = element.querySelectorAll('a');
				links.forEach((link) => {
					link.style.setProperty('text-decoration', 'none', 'important');
					link.style.setProperty('text-decoration-line', 'none', 'important');
					link.style.setProperty('text-decoration-style', 'none', 'important');
				});
			});
		}, 0);
	}
}


